import React, { FC } from 'react';
import { Icon, IconProps } from '@agria/theme/src/components/icon/Icon';

export const Circle: FC<IconProps> = (props) => (
  <Icon {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M1.495 16c0-8.01454 6.48545-14.5 14.5-14.5 8.0145 0 14.5 6.48546 14.5 14.5 0 8.0145-6.4855 14.5-14.5 14.5-8.01455 0-14.5-6.4855-14.5-14.5Zm1.71363 0c0 7.0523 5.73409 12.7864 12.78637 12.7864 7.0523 0 12.7864-5.7341 12.7864-12.7864 0-7.05227-5.7341-12.78638-12.7864-12.78638C8.94272 3.21362 3.20863 8.94773 3.20863 16Z"
      clipRule="evenodd"
    />
  </Icon>
);
